import { Component } from '@angular/core';
import { BusinessPartnerSidebarContainerComponent } from '../../../feature/business-partner-management/business-partner-sidebar/business-partner-sidebar-container/business-partner-sidebar-container.component';
import { OrderDetailsSidebarContainerComponent } from '../../../feature/order-management/order-details-sidebar/component/order-details-sidebar/order-details-sidebar-container/order-details-sidebar-container.component';

@Component({
  selector: 'pfx-app-sidebars-container',
  imports: [OrderDetailsSidebarContainerComponent, BusinessPartnerSidebarContainerComponent],
  templateUrl: './app-sidebars-container.component.html',
})
export class AppSidebarsContainerComponent {}
